import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { COLOR } from '../types/color.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Color (Cor) entity.
 * Stored in 'org/{orgId}/color'.
 */
export const colorDescriptor = {
    name: COLOR,
    label: 'Cor',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/color',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Cadastro de cores (código, descrição, abreviação, cor hexa)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique color identifier',
        },
        {
            name: 'code',
            example: 'VM01',
            label: 'Código',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
            description: 'Color code',
        },
        {
            name: 'description',
            example: 'Vermelho Carmim',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Color description',
        },
        {
            name: 'hexColor',
            example: '#9B1B30',
            label: 'Cor Hexa',
            type: 'string',
            required: true,
            description: 'Hex color value (e.g. #FF5733)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=color.descriptor.js.map